import { Injectable } from "@angular/core";

export interface IDate {
  getDate(): Date
}

@Injectable({ providedIn: 'root' })
export class DefaultDate implements IDate {
  getDate(): Date {
    return new Date();
  }
}
